import { render, staticRenderFns } from "./images.vue?vue&type=template&id=d81ce678&scoped=true&"
import script from "./images.vue?vue&type=script&lang=js&"
export * from "./images.vue?vue&type=script&lang=js&"
import style0 from "./images.vue?vue&type=style&index=0&id=d81ce678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81ce678",
  null
  
)

export default component.exports